import { Box } from '@mui/material'
import CustomDialog from 'components/CustomDialog'
import SimpleBarScroll from 'components/SimpleBar'
import React from 'react'
import DisplayConfigInWizard from '../create/DisplayConfigInWizard'

function ManageDisplayConfig({ open, handleClose, machine }) {
  return (
    <CustomDialog
      forceFullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Manage configurations"
    >
      <Box sx={{ overflow: "hidden" }}>
        <SimpleBarScroll>
          <Box padding={2}>
            <DisplayConfigInWizard  currentMachine={machine} fullGrid={true} />
          </Box>
        </SimpleBarScroll>
      </Box>
    </CustomDialog>
  )
}

export default ManageDisplayConfig